import { useState } from 'react'
import cx from 'classnames'

import './style.scss'

type TabsProps = {
  tabs: {
    title: any
    onClick?(): void
  }[]
  onChange?(i: number): void
  defaultIndex?: number
}

const Tabs = ({ tabs, defaultIndex = 0, onChange }: TabsProps) => {
  const [activeTab, setActiveTab] = useState(defaultIndex)

  const onClick = (tab, i) => {
    if (activeTab === i) return

    setActiveTab(i)

    if (tab.onClick) {
      tab.onClick()
    }

    if (onChange) {
      onChange(i)
    }
  }

  return (
    <div className="Tabs">
      {tabs.map((tab, i) => (
        <div
          key={i}
          className={cx('Tabs__item', i === activeTab && 'Tabs__item--active')}
          onClick={() => onClick(tab, i)}
        >
          {tab.title}
        </div>
      ))}
    </div>
  )
}

export default Tabs
